import classNames from "classnames";
import React, { ReactElement } from "react";
import { UserEntity } from "../../../../application/domain/user/user-entity";
import { Checkbox } from "@graffer-inc/console-design-kit";

type Props = {
  user: UserEntity;
  confirmMessage: ReactElement;
  submitLabel: string;
  onSubmit: () => void;
  cancelLabel?: string;
  onCancel: () => void;
  isLoading: boolean;
  doSendInvitation: boolean;
  setDoSendInvitation: (doSendInvitation: boolean) => void;
};

export const PasswordResetConfirmModalContent: React.FC<Props> = ({
  user,
  confirmMessage,
  cancelLabel = "キャンセルする",
  onCancel,
  submitLabel,
  onSubmit,
  isLoading,
  doSendInvitation,
  setDoSendInvitation,
}) => {
  return (
    <>
      <section className="modal-card-body">
        <div className="field">{confirmMessage}</div>
        <div className="field">
          <label className="label">ユーザーID</label>
          {user.id}
        </div>
        <div className="field">
          <label className="label">アカウント名</label>
          {user.accountName}
        </div>
        <div className="field">
          <label className="label">氏名</label>
          {user.name}
        </div>
        <div className="field">
          <label className="label">メールアドレス</label>
          {user.email || "未設定"}
        </div>
      </section>
      <section className="modal-card-foot" style={{ display: "initial" }}>
        <div className="columns">
          <Checkbox
            label=""
            description={""}
            options={[
              {
                value: "doSendInvitation",
                name: "仮パスワードをメールで送信する",
                description: !user.email
                  ? "メールアドレスの登録がないためメールで送信できません"
                  : "",
              },
            ]}
            disabled={!user.email}
            values={doSendInvitation ? ["doSendInvitation"] : []}
            onChange={(e) => {
              setDoSendInvitation(e.target.checked);
            }}
          />
        </div>
        <div className="buttons" style={{ flexWrap: "initial" }}>
          <button
            type="button"
            className="button is-fullwidth is-failure"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            className={classNames("button is-info is-fullwidth", {
              "is-loading": isLoading,
            })}
            onClick={onSubmit}
            disabled={isLoading}
          >
            {submitLabel}
          </button>
        </div>
      </section>
    </>
  );
};
